/**
 * Table Configurations Index
 * Centralized exports for all table configurations
 */

// Import all table configurations
import { ACTIVE_EVENTS_TABLE } from './activeEvents';
import { PAST_EVENTS_TABLE } from './pastEvents';
import { SALES_TABLE } from './sales';
import { TICKETS_TABLE } from './tickets';
import { USERS_TABLE } from './users';
import { PAYMENTS_TABLE } from './payments';
import { EVENTS_V2_TABLE } from './eventsV2';
import { STOCKS_TABLE } from './stocks';
import { D_COLUMNS, R_COLUMNS, C_COLUMNS, ORGANISATION_OR_VENUE_SALE_CHANNELS, SALE_REPORT_TABLES } from './saleReport';

// Export all table configurations
export const TABLE_CONFIGS = {
  ACTIVE_EVENTS: ACTIVE_EVENTS_TABLE,
  PAST_EVENTS: PAST_EVENTS_TABLE,
  SALES: SALES_TABLE,
  TICKETS: TICKETS_TABLE,
  USERS: USERS_TABLE,
  PAYMENTS: PAYMENTS_TABLE,
  EVENTS_V2: EVENTS_V2_TABLE,
  STOCKS: STOCKS_TABLE,
};

// Export individual table configurations
export {
  ACTIVE_EVENTS_TABLE,
  PAST_EVENTS_TABLE,
  SALES_TABLE,
  TICKETS_TABLE,
  USERS_TABLE,
  PAYMENTS_TABLE,
  EVENTS_V2_TABLE,
  STOCKS_TABLE,
  D_COLUMNS,
  R_COLUMNS,
  C_COLUMNS,
  ORGANISATION_OR_VENUE_SALE_CHANNELS,
  SALE_REPORT_TABLES,
};

// Helper function to get table config by name
export const getTableConfig = (tableName) => {
  return TABLE_CONFIGS[tableName] || null;
};

// Helper function to get columns by table name
export const getTableColumns = (tableName) => {
  const config = getTableConfig(tableName);
  return config ? config.columns : [];
};

// Helper function to get table defaults by table name
export const getTableDefaults = (tableName) => {
  const config = getTableConfig(tableName);
  return config ? config.defaults : {};
};

export default TABLE_CONFIGS;
